// MAISON 1822 : synchronise l'image principale, les vignettes ET le sélecteur Couleur/Contenance/
// Millésime dans les deux sens.
//
// 1) Choix Couleur/Contenance/Millésime -> filtre les vignettes sur la bonne couleur et fait
//    naviguer l'image principale vers la bonne photo (en cliquant la vignette correspondante,
//    ce qui laisse le carrousel natif du thème gérer sa propre transition -- on ne touche jamais
//    directement aux slides de l'image principale, ça cassait leur mécanisme interne).
// 2) Clic direct sur une vignette -> remet à jour les 3 sélecteurs (Couleur, Contenance,
//    Millésime) pour qu'ils correspondent à la variante de cette vignette, en déclenchant un
//    évènement "change" natif afin que le variant-picker.js du thème recalcule tout (prix, stock,
//    onglets) exactement comme s'il avait été cliqué à la main.
// 3) Filtre initial au chargement de la page -- sans ça, les vignettes affichent toutes les
//    couleurs tant que l'utilisateur n'a pas encore déclenché un premier changement d'option,
//    car le filtre ne s'appliquait auparavant que sur l'évènement "on:variant:change".

// Flag distinguishing OUR OWN programmatic thumbnail clicks (used only to switch the main image
// when a variant option changes) from REAL user clicks on a thumbnail. Without this, switching
// Contenance/Millesime would click a thumbnail whose recorded photo options might belong to a
// different Contenance (only one photo exists per Couleur+Millesime, shared across Contenance),
// and section 2 below would then force Contenance back to whatever that photo's variant was --
// silently undoing the user's own selection right after they made it.
var m1822SyntheticThumbClick = false;

function m1822GetVariantMediaData() {
  var dataEl = document.querySelector('.js-data-variant-media');
  if (!dataEl) return null;
  try {
    return JSON.parse(dataEl.textContent);
  } catch (e) {
    return null;
  }
}

function m1822SelectOption(optionName, value) {
  var container = document.querySelector('[data-option="' + optionName + '"]');
  if (!container) return;
  var inputs = container.querySelectorAll('input.opt-btn');
  for (var i = 0; i < inputs.length; i++) {
    if (inputs[i].value === value) {
      if (!inputs[i].checked) {
        inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
  }
}

// Applies the thumbnail hidden/visible filtering for a given group value (e.g. the currently
// selected Couleur). Returns the media id of the first thumbnail matching that group, or null.
function m1822FilterThumbnails(groupValue) {
  var data = m1822GetVariantMediaData();
  if (!data || !groupValue) return null;

  var mediaMap = data.media || {};
  var thumbItems = document.querySelectorAll('.thumbnails .slider__item');
  var visibleCount = 0;
  var firstMatchId = null;

  thumbItems.forEach(function (item) {
    var id = item.getAttribute('data-media-id');
    var info = mediaMap[id];
    var group = info && info.group;
    var visible = !info || group == null || group === true || group === groupValue;
    item.hidden = !visible;
    if (visible) {
      visibleCount++;
      if (group === groupValue && firstMatchId == null) firstMatchId = id;
    }
  });

  // Safety net: never leave the thumbnail strip fully blank on malformed data.
  if (visibleCount === 0) {
    thumbItems.forEach(function (item) { item.hidden = false; });
    return null;
  }

  return firstMatchId;
}

// Reads the currently checked value of the grouping option (e.g. Couleur) directly from the DOM,
// for use before any variant-change event has fired (initial page load).
function m1822GetCurrentGroupValue() {
  var data = m1822GetVariantMediaData();
  if (!data || !data.groupOptionName) return null;
  var container = document.querySelector('[data-option="' + data.groupOptionName + '"]');
  if (!container) return null;
  var checked = container.querySelector('input.opt-btn:checked');
  return checked ? checked.value : null;
}

// --- 1) Variant picker change -> filter thumbnails + switch main image ---
document.addEventListener('on:variant:change', function (evt) {
  var variant = evt.detail && evt.detail.variant;
  if (!variant) return;

  var mediaId = null;
  var data = m1822GetVariantMediaData();

  if (data) {
    var groupValue = (variant.options && data.groupOptionIndex != null) ? variant.options[data.groupOptionIndex] : null;
    if (groupValue) {
      mediaId = m1822FilterThumbnails(groupValue);
    }
  }

  // Fallback: use the variant's own assigned image if group-based matching found nothing.
  if (!mediaId) {
    mediaId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
  }

  if (!mediaId) return;

  var thumbLink = document.querySelector('.thumbnails .slider__item[data-media-id="' + mediaId + '"] a');
  if (thumbLink) {
    m1822SyntheticThumbClick = true;
    thumbLink.click();
    m1822SyntheticThumbClick = false;
    return;
  }

  var mainItems = document.querySelectorAll('.main-image .slider__item');
  mainItems.forEach(function (item) {
    item.classList.toggle('is-active', item.dataset.mediaId === String(mediaId));
  });
});

// --- 1b) Initial thumbnail filter on page load -- matches the pre-selected variant immediately,
// instead of only filtering after the user triggers a first change event. Only filters the
// thumbnail strip (never forces the main image to navigate away from what the server already
// rendered correctly). ---
function m1822InitThumbnailFilter() {
  var groupValue = m1822GetCurrentGroupValue();
  if (groupValue) {
    m1822FilterThumbnails(groupValue);
  }
}
document.addEventListener('DOMContentLoaded', m1822InitThumbnailFilter);
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  m1822InitThumbnailFilter();
}

// --- 2) Thumbnail click -> sync Couleur / Contenance / Millesime selectors ---
document.addEventListener('click', function (evt) {
  if (m1822SyntheticThumbClick) return; // ignore clicks we triggered ourselves (see section 1)

  var thumbAnchor = evt.target.closest && evt.target.closest('.thumbnails .slider__item a');
  if (!thumbAnchor) return;

  var item = thumbAnchor.closest('.slider__item[data-media-id]');
  if (!item) return;

  var mediaId = item.getAttribute('data-media-id');
  var data = m1822GetVariantMediaData();
  if (!data || !data.optionNames) return;

  var info = data.media && data.media[mediaId];
  if (!info || !info.options) return;

  for (var i = 0; i < data.optionNames.length; i++) {
    var value = info.options[i];
    if (value != null) m1822SelectOption(data.optionNames[i], value);
  }
});

// --- 3) Prune Contenance / Millesime options that don't actually exist for the current
// selection -- based on real variant existence, never on stock (this catalog is deliberately
// zero-stock everywhere, so Shopify's native stock-based "prune" mode is unusable here: it treats
// every variant as unavailable and ends up hiding options at random, including Couleur itself).
// Couleur (the first/left-most option) is never touched by this -- all colors always stay visible.
function m1822PruneDependentOptions() {
  var dataEl = document.querySelector('.js-data-all-variant-options');
  if (!dataEl) return;
  var allVariantOptions;
  try {
    allVariantOptions = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var selectors = [];
  document.querySelectorAll('[data-option]').forEach(function (container) {
    var index = parseInt(container.getAttribute('data-index'), 10) - 1;
    if (isNaN(index)) return;
    var checked = container.querySelector('input.opt-btn:checked');
    selectors.push({ container: container, index: index, value: checked ? checked.value : null });
  });
  selectors.sort(function (a, b) { return a.index - b.index; });

  // Skip the first selector (Couleur): its own siblings are never pruned.
  for (var i = 1; i < selectors.length; i++) {
    var prior = selectors.slice(0, i);
    var current = selectors[i];
    var inputs = current.container.querySelectorAll('input.opt-btn');
    var visibleCount = 0;

    inputs.forEach(function (input) {
      var candidate = input.value;
      var exists = allVariantOptions.some(function (opts) {
        for (var p = 0; p < prior.length; p++) {
          if (opts[prior[p].index] !== prior[p].value) return false;
        }
        return opts[current.index] === candidate;
      });
      var label = input.nextElementSibling;
      if (label) label.style.display = exists ? '' : 'none';
      input.tabIndex = exists ? 0 : -1;
      if (exists) visibleCount++;
    });

    // Safety net: never end up with zero visible options.
    if (visibleCount === 0) {
      inputs.forEach(function (input) {
        var label = input.nextElementSibling;
        if (label) label.style.display = '';
        input.tabIndex = 0;
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', m1822PruneDependentOptions);
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  m1822PruneDependentOptions();
}
document.addEventListener('change', function (evt) {
  if (evt.target && evt.target.classList && evt.target.classList.contains('opt-btn')) {
    m1822PruneDependentOptions();
  }
});
